import React from 'react';
import "./HowItWorks.css";
import { FaPhone, FaPaintBrush, FaFileSignature } from 'react-icons/fa';

const HowItWorks = () => {
  const steps = [
    {
      icon: <FaPhone size={50} className="text-brown" />,
      title: "1. Contacto y estudio del inmueble",
      paragraph: "Nos ponemos en contacto contigo para conocer tu propiedad y realizar un estudio detallado de su potencial."
    },
    {
      icon: <FaPaintBrush size={50} className="text-brown" />,
      title: "2. Adecuación y decoración (home staging)",
      paragraph: "Preparamos el inmueble con decoración profesional para maximizar su atractivo y valor de alquiler."
    },
    {
      icon: <FaFileSignature size={50} className="text-brown" />,
      title: "3. Firma del contrato de gestión y empiezas a cobrar",
      paragraph: "Firmamos el acuerdo y comenzamos la gestión completa, garantizando tu renta mensual desde el primer día."
    }
  ];

  return (
    <div className='howitworks section-p' id="howitworks">
        <div className='container'>
            <div className='howitworks-content'>
                <div className='section-title'>
                    <h3 className='text-brown'>Cómo <span className='text-dark'>Funciona</span></h3>
                    <p className='text'>Proceso simple en 3 pasos para que empieces a beneficiarte de tu propiedad sin complicaciones.</p>
                </div>

                <div className='howitworks-list grid'>
                    {
                        steps.map((step, index) => {
                            return (
                                <div className='howitworks-item text-center' key={index}>
                                    <div className='step-icon'>{step.icon}</div>
                                    <h4 className='fs-22 fw-5 op-08'>{step.title}</h4>
                                    <p className='text mx-auto'>{step.paragraph}</p>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    </div>
  )
}

export default HowItWorks